import React from 'react';
import styled from 'styled-components'
import logo from 'common/src/assets/image/saas/logo-full.svg';

export default () => <img src={logo} width="180" height="48" />
